export const usuarioModel = {
  ac: '',
  nu: '',
  nc: '',
};
